import {
    ADD_CONTADOR_MAQUINA,
    DELETE_CONTADOR_MAQUINA,
    MODIFY_CONTADOR_MAQUINA
} from '../constants/action_types';


export function addContadorDeMaquina(contador) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_CONTADOR_MAQUINA, payload: contador });
    }
}

export function modifyContadorDeMaquina(contador) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_CONTADOR_MAQUINA, payload: contador });
    }
}

export function removeContadorDeMaquina(contador) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_CONTADOR_MAQUINA, payload: contador });
    }
}